module.exports = __webpack_public_path__ + "img/bg-2c3a28.jpg";